import type { SVGProps } from "react";
export interface FileShieldIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function FileShieldIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: FileShieldIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M2.875 19V5A4.125 4.125 0 0 1 7 .875h6.586c.293 0 .58.063.844.177l.022.009q.258.115.48.296l.157.14 5.414 5.415c.18.18.322.39.426.618q.012.022.022.047c.113.262.174.547.174.838V19A4.125 4.125 0 0 1 17 23.125H7A4.125 4.125 0 0 1 2.875 19m12.25-13c0 .484.392.875.875.875h1.285l-2.16-2.16zm-10 13c0 1.035.84 1.875 1.875 1.875h10c1.036 0 1.875-.84 1.875-1.875V9.125H16A3.125 3.125 0 0 1 12.876 6V3.125H7c-1.036 0-1.875.84-1.875 1.875z"
      />
      <path
        fill={color}
        d="m14.376 13.385-2.377-1.188-2.374 1.188v1.738l.015.168c.07.407.389.906.977 1.45.47.436 1 .792 1.382 1.026.383-.234.913-.59 1.385-1.026.671-.621.992-1.185.992-1.618zm2.25 1.738-.012.262c-.106 1.297-.974 2.335-1.702 3.008a11 11 0 0 1-1.75 1.301l-.395.232a1.58 1.58 0 0 1-1.35.086l-.184-.086c-.416-.232-1.325-.774-2.144-1.532-.728-.674-1.598-1.712-1.704-3.01l-.01-.261v-2.124c0-.616.348-1.178.898-1.454l3-1.5.176-.074a1.63 1.63 0 0 1 1.103 0l.174.074 3 1.5.198.116c.435.3.701.8.701 1.338v2.124Z"
      />
    </svg>
  );
}
